module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "header0801",
      "epub:type": "chapter",
      "id": "ch08",
      "role": "doc-chapter"
    }
  }, [_c('header', {
    attrs: {
      "id": "header0801"
    }
  }, [_c('h1', {
    staticClass: "cn"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chiseneca0005#rch08"
    }
  }, [_vm._v("Letter 8")])]), _vm._v(" "), _c('h1', {
    staticClass: "ct"
  }, [_vm._v("Writing as a form of service")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("From Seneca to Lucilius")]), _vm._v(" "), _c('h1', {
    staticClass: "cs",
    attrs: {
      "role": "doc-subtitle"
    }
  }, [_vm._v("Greetings")])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p1",
      "id": "c8p1r",
      "role": "doc-noteref"
    }
  }, [_vm._v("1")])])]), _vm._v(" “Are you, then, telling me to avoid the crowd, retire, and content myself with my private thoughts? What about those instructions of your school that bid us die in action?”*")]), _vm._v(" "), _c('p', [_vm._v("Well, do you think this is inaction that I am urging upon you? Here is the reason I have hidden myself away and closed the doors: to benefit the greater number. Not one of my days is spent in leisure, and I claim a part of the nights for study. I have no time for sleep, until it overcomes me; my eyes are exhausted and drooping with late hours, but I keep them to the task. "), _c('span', {
    staticClass: "pnum"
  }, [_vm._v("2")]), _vm._v(" I have withdrawn not only from society but from business, and especially from my own business. The work that I am doing "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "15",
      "id": "p15",
      "role": "doc-pagebreak"
    }
  }), _vm._v("is for posterity: it is they who can benefit from what I write. I am committing to the page some healthful admonitions, like the recipes for useful salves. I have found these effective on my own sores, which, even if not completely healed, have ceased to spread. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p3",
      "id": "c8p3r",
      "role": "doc-noteref"
    }
  }, [_vm._v("3")])])]), _vm._v(" The right path, which I myself discovered late in life when weary from wandering, I now point out to others.")]), _vm._v(" "), _c('p', [_vm._v("My cry is this:*")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqf"
  }, [_vm._v("“Avoid those things that please the many, the gifts that fortune brings. Be suspicious; be timid; resist every good that comes by chance. It is by the allurements of hope that the fish is caught, the game snared. Do you think these are the blessings of fortune? They are traps. Any one of you who wants to live in safety must make every effort to shun those baited favors amidst which we, poor creatures, are deceived. We think we have hold of them, when in fact they have hold of us.")]), _vm._v(" "), _c('p', {
    staticClass: "bq"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("4")]), _vm._v(" “That career of yours leads over a cliff. To leave such an exalted life, you have to fall. And once prosperity begins to push us over, we cannot even resist. We could wish to fall only once, or at least to fall from an upright position, but we are not allowed. Fortune does not only overturn us: it upends us, and then smashes us.")]), _vm._v(" "), _c('p', {
    staticClass: "bql"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("5")]), _vm._v(" “Hold therefore to this sound and saving rule of life: indulge the body only to the extent that suffices for health. Deal sternly with it, lest it fail to obey the mind. Let food be for appeasing hunger, drink for satisfying thirst, clothing a protection against cold, a house a shelter against inclement weather. Whether that house is built of sod or of variegated marble from foreign lands is of no significance: believe me, a person can be sheltered just as well with thatch "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "16",
      "id": "p16",
      "role": "doc-pagebreak"
    }
  }), _vm._v("as with gold. Scorn all those things that superfluous labor sets up for decoration and for show: keep in mind that nothing but the mind is marvelous, that to the great mind, nothing else is great.”")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_vm._v("6")]), _vm._v(" If I am saying all this to myself and to posterity, do you not think that I am doing more to benefit them than I used to when I was an advocate, going down to post bail or affixing a seal to someone’s will or lending my voice and aid to some senatorial candidate? Believe me: those who appear to be doing nothing are doing greater things—they are dealing with matters both human and divine.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p7",
      "id": "c8p7r",
      "role": "doc-noteref"
    }
  }, [_vm._v("7")])])]), _vm._v(" But now I must make an end; and as has become my custom, I must pay for my letter. This will be done, but not on my own charge. I am still plundering Epicurus, in whose work I today found this saying:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("You should become a slave to philosophy, that you may attain true liberty.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Those who give themselves in obedient service to philosophy are not put off from day to day: they have their liberty-turn* at once, for this slavery to philosophy is true freedom.")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p8",
      "id": "c8p8r",
      "role": "doc-noteref"
    }
  }, [_vm._v("8")])])]), _vm._v(" Perhaps you will ask me why I mention so many fine sayings from Epicurus rather than from our own school. But is there any reason why you should consider them to belong to Epicurus rather than to the public? So many poets say things that philosophers have said, or that they ought to have said! I need not refer to the tragedians or to the authors of our "), _c('i', [_vm._v("fabulae togatae")]), _vm._v(" (for those plays too have a serious element; they are in between tragedy and comedy).* Plenty of highly eloquent verses are to be found even in the mime. Many lines of Publilius "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "17",
      "id": "p17",
      "role": "doc-pagebreak"
    }
  }), _vm._v("are such as would befit not only the writer of comedy but even the tragedian. "), _c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p9",
      "id": "c8p9r",
      "role": "doc-noteref"
    }
  }, [_vm._v("9")])])]), _vm._v(" I will report one verse of his that is relevant to philosophy and indeed to the topic I was just discussing. In it he asserts that things that come by chance ought not to be regarded as belonging to us:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("Whatever comes by wishing is not your possession.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_c('span', {
    staticClass: "pnum"
  }, [_c('sup', {
    staticClass: "footnote-out"
  }, [_c('a', {
    staticClass: "enref",
    attrs: {
      "href": "#/chiseneca0059#c8p10",
      "id": "c8p10r",
      "role": "doc-noteref"
    }
  }, [_vm._v("10")])])]), _vm._v(" I remember that you yourself expressed the same idea in a much better and more concise way:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("What fortune makes your own is not your own.")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("Nor will I omit another, even better saying of yours:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "bqs"
  }, [_vm._v("The good that can be given can be taken.*")])]), _vm._v(" "), _c('p', {
    staticClass: "pcon"
  }, [_vm._v("I am not charging these against your account: they come to you from yourself.")]), _vm._v(" "), _c('p', [_vm._v("Farewell.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a55cb844","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-seneca-0014.vue
// module id = 93
// module chunks = 0